import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import OpalCard from '../../opal/OpalCard'
import Avatar from '../../atoms/Avatar'
import { useFormattingContext } from '../../organisms/FormattingProvider/FormattingContext'

export const MetricCard = ({
  title: _title,
  description: _description,
  metric: _metric,
  image,
  formats,
  componentClasses,
  style,
  ...rest
}) => {
  const { formatter } = useFormattingContext()

  const title = useMemo(() => formats?.title ? formatter(_title, formats.title) : _title, [formats, _title, formatter])
  const description = useMemo(() => formats?.description ? formatter(_description, formats.description) : _description, [formats, _description, formatter])
  const metric = useMemo(() => formats?.metric ? formatter(_metric, formats.metric) : _metric, [formats, _metric, formatter])

  return (
    <OpalCard className={clsx('flex gap-sm w-full p-4 items-center', componentClasses?.container)} style={style} {...rest}>
      {!!image?.length && (
        <Avatar
          src={image}
          customClassName={componentClasses.avatar}
        />
      )}
      <div className='flex-1'>
        {!!title?.length && <p className={clsx('font-size-lg m-0', componentClasses?.title)}>{title}</p>}
        {!!description?.length && <p className={clsx('font-size-sm m-0', componentClasses?.description)}>{description}</p>}
      </div>
      {!!metric && (
        <div>
          <p className={clsx('font-size-2xl m-0', componentClasses?.metric)}>{metric}</p>
        </div>
      )}
    </OpalCard>
  )
}

MetricCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  metric: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  formats: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    metric: PropTypes.string
  }),
  componentClasses: PropTypes.shape({
    container: PropTypes.string,
    avatar: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    metric: PropTypes.string
  }),
  style: PropTypes.object
}
